import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16, IcoTrash16 } from '@onefootprint/icons';
import { IconButton, LinkButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type EnumValuesInputProps = {
  values: string[];
  onChange: (values: string[]) => void;
  hasError?: boolean;
};
export const EnumValuesInput = t0 => {
  const $ = _c(29);
  const {
    values,
    onChange,
    hasError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.task.field.enum"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== onChange || $[2] !== values) {
    t2 = (index, value) => onChange(values.map((v, i) => i === index ? value : v));
    $[1] = onChange;
    $[2] = values;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const update = t2;
  let t3;
  if ($[4] !== onChange || $[5] !== values) {
    t3 = index_0 => onChange(values.filter((_, i_0) => i_0 !== index_0));
    $[4] = onChange;
    $[5] = values;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const removeAt = t3;
  let t4;
  if ($[7] !== onChange || $[8] !== values) {
    t4 = () => onChange([...values, ""]);
    $[7] = onChange;
    $[8] = values;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const add = t4;
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <span className="text-label-3 text-primary">{t5}</span>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== hasError || $[15] !== removeAt || $[16] !== t || $[17] !== update || $[18] !== values) {
    t7 = values.length > 0 && <div className="flex flex-col gap-1">{values.map((value_0, i_1) => <div key={i_1} className="flex items-center gap-2"><input aria-label={t(_temp2)} className={cx("h-6 min-w-0 flex-1 rounded border bg-primary px-2 text-label-3 text-primary outline-none focus:border-accent", hasError && !value_0.trim() ? "border-error" : "border-tertiary")} value={value_0} placeholder={t(_temp3)} onChange={e => update(i_1, e.target.value)} /><IconButton size="tiny" aria-label={t(_temp4)} icon={IcoTrash16} destructive={true} onClick={() => removeAt(i_1)} className="[&_svg]:size-3.5" /></div>)}</div>;
    $[14] = hasError;
    $[15] = removeAt;
    $[16] = t;
    $[17] = update;
    $[18] = values;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t) {
    t8 = t(_temp5);
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== add || $[23] !== t8) {
    t9 = <div className="self-start"><LinkButton variant="caption-3" iconComponent={IcoPlusSmall16} iconPosition="left" onClick={add}>{t8}</LinkButton></div>;
    $[22] = add;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t9) {
    t10 = <div className="mt-2 flex flex-col gap-1">{t6}{t7}{t9}</div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
function _temp($) {
  return $.label;
}
function _temp2($_0) {
  return $_0.valueAria;
}
function _temp3($_1) {
  return $_1.valuePlaceholder;
}
function _temp4($_2) {
  return $_2.removeAria;
}
function _temp5($_3) {
  return $_3.addValue;
}